/// <amd-module name="Build/DesignerExtensions/YamlAssistantLibrary/Components/ExampleContributedSnippetForm" />
/** 
 * Extension contract:
 * {
 *      "id": id for the contribution,
 *      "type": this needs to be -> "ms.vss-build-web.yaml-contributed-snippet-form-type"
 *      "targets": [
 *          string array of targets, these are the ids of the hubs/sections your contribution is on
 *      ],
 *      "properties": {
 *          properties follow the contract defined with ContributedSnippetFormType in yaml-snippet-library/contracts/Types.d.ts
 *      }
 * }
 * 
 * Example extension:
 * {
 *      "id": "example-contributed-snippet-form",
 *      "type": "ms.vss-build-web.yaml-contributed-snippet-form-type",
 *      "targets": [
 *          "ms.vss-build-web.ci-designer-hub",
 *      ],
 *      "properties": {
 *          "snippetId": "5541a522-603c-47ad-91fc-a4b1d163081b", // this is the ID for the .NET Core task
 *          "componentId": "example-contributed-snippet-form",
 *          "componentType": "example-contributed-snippet-form",
 *          "dependencies": [
 *              "example-contributed-snippet-form-data-provider"
 *          ]
 *      }
 * }
 * 
 * Example component usage:
 * {
 *      ...
 *      public render(): JSX.Element {
 *          return <ContributedSnippetForm
 *                      onYamlGenerated={call this when you generate yaml}
 *                      onInputsCompleted={call this when you have the complete input dictionary}
 *                      onDismiss={call this when your form gets dismissed}
 *                      snippet={the snippet to render in the default form (or just the id if rendering contributed)}
 *                      componentData={{
 *                          id={if known, id of the component to load}
 *                          type={if known, type of the component to load}
 *                          props={extra props to pass to the contributed component on render}
 *                          dependencies={array of ids of extra dependencies to load such as data providers}
 *                      }} />
 *              />;
 *      }
 *      ...
 * }
 *
 * Example component:
 */
import * as React from "react";
import { Components, VssComponent } from "VSS/Platform/Layout";
import { IVssPageContext } from "VSS/Platform/Context";

// this contract is passed to the extension on render along with whatever props were passed to ContributedSnippetForm
import { SnippetFormProvider } from "Build/DesignerExtensions/YamlAssistantLibrary/Contracts/Types";

export class ExampleContributedSnippetForm extends VssComponent<SnippetFormProvider> {

    public render(): JSX.Element {
        return <div>{"Render your content here"}</div>;
    }
}

// this component name needs to match the componentType prop in the extension
Components.add("example-contributed-snippet-form", ExampleContributedSnippetForm);
